module.exports = __webpack_public_path__ + "img/clock.06efc12e.svg";